// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3tEDH","header":"MessagesList_header__P8FnP","chat":"MessagesList_chat__87p0O"};